import { getAdjacentGoBoardCoordinates } from "@/utils/get-adjacent-go-board-coordinates";
import { getGoBoardCoordinateKey } from "@/utils/get-go-board-coordinate-key";

const getGoBoardGroup = (
  board: Array<Array<GoBoardStone | null>>,
  startingCoordinate: GoBoardCoordinate,
): GoBoardGroup => {
  const boardSize = board.length;
  const startingStone = board[startingCoordinate.row]?.[startingCoordinate.column];

  if (!startingStone) {
    return { liberties: [], stones: [] };
  }

  const pendingCoordinates = [startingCoordinate];
  const visitedCoordinateKeys = new Set<number>();
  const libertyCoordinateKeys = new Set<number>();
  const liberties: GoBoardCoordinate[] = [];
  const stones: GoBoardCoordinate[] = [];

  while (pendingCoordinates.length > 0) {
    const coordinate = pendingCoordinates.pop();

    if (!coordinate) {
      continue;
    }

    const coordinateKey = getGoBoardCoordinateKey(coordinate, boardSize);

    if (visitedCoordinateKeys.has(coordinateKey)) {
      continue;
    }

    visitedCoordinateKeys.add(coordinateKey);
    stones.push(coordinate);

    for (const adjacentCoordinate of getAdjacentGoBoardCoordinates(coordinate, boardSize)) {
      const adjacentStone = board[adjacentCoordinate.row]?.[adjacentCoordinate.column];

      if (!adjacentStone) {
        const libertyCoordinateKey = getGoBoardCoordinateKey(adjacentCoordinate, boardSize);

        if (!libertyCoordinateKeys.has(libertyCoordinateKey)) {
          libertyCoordinateKeys.add(libertyCoordinateKey);
          liberties.push(adjacentCoordinate);
        }

        continue;
      }

      if (adjacentStone.color === startingStone.color) {
        pendingCoordinates.push(adjacentCoordinate);
      }
    }
  }

  return { liberties, stones };
};

export { getGoBoardGroup };
